import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { withLocale, SITE } from "@/lib/seo";

// items: [{label:{en,ar}, to}] ; last item is current (no link)
export const Breadcrumbs = ({ items }) => {
  const { t, lang, isAr } = useLang();
  return (
    <nav aria-label="breadcrumb" className="flex items-center gap-1.5 text-sm text-muted flex-wrap" data-testid="breadcrumbs">
      {items.map((it, i) => (
        <span key={i} className="inline-flex items-center gap-1.5">
          {it.to ? <Link to={withLocale(lang, it.to)} className="hover:text-navy transition-colors">{t(it.label)}</Link> : <span className="text-ink font-medium">{t(it.label)}</span>}
          {i < items.length - 1 && <ChevronRight className={`h-3.5 w-3.5 opacity-50 ${isAr ? "rotate-180" : ""}`} />}
        </span>
      ))}
    </nav>
  );
};

export const breadcrumbSchema = (lang, items) => ({
  "@context": "https://schema.org", "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem", position: i + 1,
    name: it.label[lang] || it.label.en,
    item: it.to ? `${SITE}/${lang}${it.to === "/" ? "" : it.to}` : undefined,
  })),
});
